export const isInomatCategory: (catId: any) => boolean =
  (catId) => {
    return catId == process.env.REACT_APP_INOMAT_CAT_ID || catId == process.env.REACT_APP_INOMAT_TBL_CAT_ID;
};

//A termék kitöltéséhez segédfüggvény - ha új sort adunk hozzá a felületen akkor melyik terméket fillelje be
export const getPredefinedProductForInomat: (catId: any) => string | undefined =
(catId) => {
    if(catId == process.env.REACT_APP_INOMAT_CAT_ID) {
        return process.env.REACT_APP_INOMAT_PANEL_ID;
    } 
    if(catId == process.env.REACT_APP_INOMAT_TBL_CAT_ID) {
        return process.env.REACT_APP_INOMAT_TBL_PANEL_ID;
    } 
    return undefined;
};

//A színek feltöltéséhez segédfüggvény - inomatnál kell egy extra network request hamarabb az eltüntetett product mező miatt
export const isInomatProduct: (productId: any) => boolean =
(productId) => {
    return productId == process.env.REACT_APP_INOMAT_PANEL_ID || productId == process.env.REACT_APP_INOMAT_TBL_PANEL_ID;
};